import React from 'react';
import PropTypes from 'prop-types';

import ShippingGroups from './components/ShippingGroups';
import StepTitle from '../StepTitle';

const Delivery = ({
  goToTab,
  deliveryInfo,
  shippingGroups,
  hasProtectionNext,
  updateDeliveryInfo,
  shippingGroupsLoading,
  cart,
  avoCheckoutStepCompleted,
  shipping,
}) => (
  <>
    <div className="flex flex-row flex-wrap justify-between items-start">
      <StepTitle number="3">How should we deliver your furniture?</StepTitle>
    </div>

    <ShippingGroups
      goToTab={goToTab}
      deliveryInfo={deliveryInfo}
      shippingGroups={shippingGroups}
      hasProtectionNext={hasProtectionNext}
      updateDeliveryInfo={updateDeliveryInfo}
      shippingGroupsLoading={shippingGroupsLoading}
      cartData={cart}
      avoCheckoutStepCompleted={avoCheckoutStepCompleted}
      shipping={shipping}
    />
  </>
);

Delivery.propTypes = {
  avoCheckoutStepCompleted: PropTypes.bool,
  cart: PropTypes.object.isRequired,
  deliveryInfo: PropTypes.object.isRequired,
  goToTab: PropTypes.func.isRequired,
  hasProtectionNext: PropTypes.bool,
  shipping: PropTypes.object.isRequired,
  shippingGroups: PropTypes.array.isRequired,
  shippingGroupsLoading: PropTypes.bool,
  updateDeliveryInfo: PropTypes.func.isRequired,
};

export default Delivery;
